import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
// import Close from "@material-ui/icons/Close";
// import Assignment from "@material-ui/icons/Assignment";
import Face from "@material-ui/icons/Face";
import Phone from "@material-ui/icons/Phone";
import Home from "@material-ui/icons/Home";
import Edit from "@material-ui/icons/Edit";
// import Timeline from "@material-ui/icons/Timeline";
// import Code from "@material-ui/icons/Code";
// import Group from "@material-ui/icons/Group";
import Email from "@material-ui/icons/Email";
import Check from "@material-ui/icons/Check";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
// import Card from "components/Card/Card.jsx";
import TextField from '@material-ui/core/TextField';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Slide from '@material-ui/core/Slide';

import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class AddContactMainData extends React.Component {
  // constructor(props) {
  //   super(props);
  //
  // }


  render() {
    const { classes, propertyData } = this.props;
    return (
            <div>
              <GridContainer>

                <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
                  <TextField
                      id="name"
                      label="Name"
                      name="name"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      value={this.props.propertyData.name.value}
                      onChange={(e) => this.props.changeHandler(e)}
                    />


                    <TextField
                        id="phone"
                        label="Phone"
                        name="phone"
                        className={classes.textField}
                        margin="normal"
                        fullWidth
                        value={this.props.propertyData.phone.value}
                        onChange={(e) => this.props.changeHandler(e)}
                      />


                  <TextField
                      id="address"
                      label="Address"
                      name="address"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      value={this.props.propertyData.address.value}
                      onChange={(e) => this.props.changeHandler(e)}
                    />

  
                </GridItem>
                <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>

                    <CustomInput
                      labelText="Surname"
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                      }}
                      inputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            className={classes.inputAdornment}
                          >
                            <Face className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        )//,
                         //placeholder: "First Name..."
                      }}
                    />
                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Email className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                        placeholder: "Email"
                      }}
                    />
                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Edit className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                        placeholder: "Description"
                      }}
                    />



                </GridItem>

              </GridContainer>

              <GridContainer>



              </GridContainer>

            </div>

    );
  }
}

export default withStyles(javascriptStyles)(AddContactMainData);
